<template>
    <div class=' index'>
        <iframe :src="$route.query.url" frameborder="0" width="100%" height='100%'></iframe>
    </div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        watch: {},
        computed: {},
        created() {},
        mounted() {
        },
        methods: {},
    };
</script>
<style lang="scss" scoped>
    .index {
        // width: 100%;
        height: 100%;
    }
</style>